import api from '@/api/api';
import {useAuthStore} from "@/stores/auth";

const ENDPOINT = 'auth';

class AuthService {

    async hasAccess(page) {
        try {
            const response = await api().get(`/${ENDPOINT}/permission/${page}`);
            return response.data;
        } catch (error) {
            if (401 === error.response?.status) {
                await useAuthStore().logout();
            }
            return false;
        }
    }

    getMenu() {
        return api().get(`/${ENDPOINT}/menu`);
    }
}

export default new AuthService();